/**
 * Home IA · Capacidades de entidad (H10/H12). Modelos espejo de los DTO camelCase del backend,
 * disparados desde una entidad visible del radar R4. READ-ONLY sobre lo que el backend ya recortó
 * por permisos de fuente: nunca se listan documentos/preguntas de fuentes no visibles.
 */

/** H10 · Una pregunta sugerida para una entidad visible (texto listo para precargar en el chat). */
export interface EntitySuggestedQuestion {
  text: string;
  category: string;
}

/** H10 · Respuesta de `GET /home-ia/entities/{id}/suggested-questions`. Gate `knowledge_hub`. */
export interface EntitySuggestedQuestionsResponse {
  entityId: string;
  questions: EntitySuggestedQuestion[];
  featureAvailable: boolean;
}

/** H12 · Una fuente candidata (documento visible) para generar desde una entidad. */
export interface EntityGenerationSource {
  documentId: string;
  filename: string;
  type: string;
  versionNo: number;
  reason: string;
}

/** H12 · Respuesta de `GET /home-ia/entities/{id}/generation-sources`. Gate `doc_generation`. */
export interface EntityGenerationSourcesResponse {
  entityId: string;
  sources: EntityGenerationSource[];
  featureAvailable: boolean;
}

/**
 * Estado de navegación que la entrada al chat (H11) precarga: texto sugerido en el input y el
 * identificador interno seguro de la entidad. El envío es SIEMPRE manual (el usuario confirma);
 * el backend re-resuelve permisos y hace retrieval normal sobre `/api/query` con el texto.
 */
export interface HomeEntityChatPrefill {
  text: string;
  entityId: string;
}

export interface HomeEntityChatNavigationState {
  homeIaPrefill?: HomeEntityChatPrefill;
}

/** Respuesta H10 "feature no disponible" (404 => ocultar chips sin propagar el error). */
export const ENTITY_QUESTIONS_FEATURE_OFF: EntitySuggestedQuestionsResponse = {
  entityId: '',
  questions: [],
  featureAvailable: false,
};

/** Respuesta H12 "feature no disponible" (404 => ocultar botón de generación sin propagar). */
export const ENTITY_GENERATION_FEATURE_OFF: EntityGenerationSourcesResponse = {
  entityId: '',
  sources: [],
  featureAvailable: false,
};
